export const APARTMENTS = [
     { name: "–", value: 0 },
    { name: "Apartament 1", value: 1 },
    { name: "Apartament 2", value: 2 },
    { name: "Apartament 3", value: 3 },
    { name: "Apartament 4", value: 4 },
    { name: "Apartament 5", value: 5 },
];

export const APARTMENT_MAP = Object.fromEntries(
    APARTMENTS.map((a) => [a.value, a.name])
);